import React, { useEffect, useState } from 'react';
import {
  Box,
  Flex,
  Select,
  VStack,
  Text,
  Button,
  useTheme,
} from '@chakra-ui/react';
import PromptConfig from './PromptConfig';
import { server } from '../../services/serverComm';
import { useAuth0 } from '@auth0/auth0-react';
import QuestionContextEditor from './QuestionContextEditor';
import PromptConfigEditor from './PromptConfigEditor';

const AdminConfig = () => {
  const [configs, setConfigs] = useState({ prompts: {} });
  const [selectedPrompt, setSelectedPrompt] = useState('');
  const [currentTab, setCurrentTab] = useState('prompts');
  const [saving, setSaving] = useState(false);
  const { getAccessTokenSilently, user } = useAuth0();
  const theme = useTheme();

  // On component load, fetch the data
  useEffect(() => {
    const getData = async () => {
      const accessToken = await getAccessTokenSilently();
      const response = await server.getPrompts(accessToken);
      const data = await response.json();

      setConfigs(data);

      // Set the first prompt as the initially selected prompt
      if (Object.keys(data.prompts).length > 0) {
        setSelectedPrompt(Object.keys(data.prompts)[0]);
      }
    };

    getData();
  }, []);

  const saveConfigUpdates = async () => {
    setSaving(true);
    const accessToken = await getAccessTokenSilently();
    console.debug(JSON.stringify(configs));
    await server.updatePrompts(accessToken, configs);
    setSaving(false);
  };

  const updatePrompt = (title, newSysPrompt) => {
    setConfigs((prev) => {
      let prompts = prev.prompts;
      const newPrompts = {
        ...prompts,
        [title]: { ...prompts[title], SYSTEM: newSysPrompt },
      };
      return { ...prev, prompts: newPrompts };
    });
  };

  const updateQContextList = (newQContextList) => {
    setConfigs((prev) => ({
      ...prev,
      questionContextList: newQContextList,
    }));
  };

  const updateGeneralContext = (newGeneralContext) => {
    setConfigs((prev) => ({ ...prev, generalContext: newGeneralContext }));
  };

  const handleSelectChange = (event) => {
    setSelectedPrompt(event.target.value);
  };

  const TabLink = ({ panelId, text }) => (
    <VStack mr={4} spacing={0}>
      <Text
        onClick={() => setCurrentTab(panelId)}
        style={{
          color: currentTab === panelId ? theme.colors.blueOne : '',
          fontWeight: currentTab === panelId ? '700' : '400',
          textAlign: 'center',
          margin: '4px 8px',
          cursor: 'pointer',
        }}
      >
        {text}
      </Text>
      {currentTab === panelId ? (
        <Box
          marginTop='0px'
          h='5px'
          borderRadius='5px'
          alignSelf='stretch'
          background={theme.colors.blueOne}
        />
      ) : (
        <Box
          marginTop='0px'
          h='5px'
          borderRadius='5px'
          alignSelf='stretch'
          background={theme.colors.transparent}
        />
      )}
    </VStack>
  );

  const renderPromptConfigTab = () => {
    return (
      <Box>
        <Select
          background={theme.colors.bgGrey2}
          placeholder='Select a prompt'
          maxWidth={300}
          onChange={handleSelectChange}
          value={selectedPrompt}
          ml={4}
        >
          {Object.keys(configs.prompts).map((title) => (
            <option key={title} value={title}>
              {title}
            </option>
          ))}
        </Select>
        {selectedPrompt && configs.prompts[selectedPrompt] && (
          <PromptConfig
            key={selectedPrompt}
            template={configs.prompts[selectedPrompt].TEMPLATE}
            systemPrompt={configs.prompts[selectedPrompt].SYSTEM}
            updatePrompt={(e) => updatePrompt(selectedPrompt, e.target.value)}
            forceDisable={!!configs.prompts[selectedPrompt].disableUpdate}
          />
        )}
      </Box>
    );
  };

  const renderQContextConfigTab = () => {
    return;
  };

  return (
    <Flex
      direction='column'
      h={'calc(100vh - 64px - 47px - 60px)'} //Remove the header height, footer height, and the margin
      m={'30px auto'}
      p={4}
      borderRadius='5px'
      // gap="10px"
      maxWidth='1140px'
      width='100%'
      // bg={theme.colors.bgGrey}
      bg={theme.colors.tableHeaderBlue}
      position='relative'
      overflow='auto'
    >
      <Box display='flex' alignItems='center' ml={4} mb={4}>
        <TabLink panelId={'prompts'} text='Prompts' />
        <TabLink panelId={'qContext'} text='Question Context' />
        <Button
          position={'sticky'}
          ml='auto'
          colorScheme={saving ? 'gray' : 'blue'}
          onClick={saveConfigUpdates}
        >
          {saving ? 'Saving...' : 'Save Changes'}
        </Button>
      </Box>
      {/* {currentTab === "prompts" && renderPromptConfigTab()} */}
      {
        currentTab === 'prompts' && renderPromptConfigTab()
        //No clue why this doesn't work the same?
        // <PromptConfigEditor
        //     configs={configs}
        //     selectedPrompt={selectedPrompt}
        //     handleSelectChange={handleSelectChange}
        //     handleSysPromptChange={handleSysPromptChange}
        // />
      }
      {currentTab === 'qContext' && (
        <QuestionContextEditor
          configs={configs}
          updateQContextList={updateQContextList}
          updateGeneralContext={updateGeneralContext}
        />
      )}
    </Flex>
  );
};

export default AdminConfig;
